/*! Lazy Image */
class LazyImage extends HTMLImageElement {
  constructor() {
    super();

    this.wrapper = this.closest('.media-wrapper');
    if (this.wrapper === null) return;

    this.handleLazy();
    addEventListener('resize', this.handleLazy.bind(this), true);

    const observer = new MutationObserver((changes) => {
      changes.forEach((change) => {
        if (change.attributeName.includes('src') || change.attributeName.includes('srcset')) {
          this.handleLazy();
        }
      });
    });
    observer.observe(this, {attributes : true});
  }

  handleLazy () {
    const mql = window.matchMedia('(min-width: 750px)');
    if (mql.matches && this.classList.contains('medium-hide')) return;
    if (!mql.matches && this.classList.contains('small-hide')) return;
    if (this.complete || this.classList.contains('loaded')) return;
    
    // Ensure wrapper has relative positioning
    if (window.getComputedStyle(this.wrapper).position === 'static') {
      this.wrapper.style.position = 'relative';
    }
    
    // Add custom loader with background
    if (!this.wrapper.querySelector('.custom-loader-wrapper')) {
      const loaderWrapper = document.createElement('div');
      loaderWrapper.className = 'custom-loader-wrapper';
      loaderWrapper.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background-color: rgba(255, 255, 255, 0.8); z-index: 100; pointer-events: none;';
      
      const loader = document.createElement('img');
      loader.className = 'custom-loader';
      loader.src = 'https://cdn.shopify.com/s/files/1/0016/9007/5203/files/arch-loader.webp?v=1759466446';
      loader.style.cssText = 'width: 60px; height: 60px; object-fit: contain;';
      
      loaderWrapper.appendChild(loader);
      this.wrapper.appendChild(loaderWrapper);
    }
    
    this.addEventListener('load', () => {
      const loaded = () => {
        this.classList.add('loaded');
        
        // Remove custom loader
        const loaderWrapper = this.wrapper.querySelector('.custom-loader-wrapper');
        if (loaderWrapper) loaderWrapper.remove();
      };

      window.requestIdleCallback ? window.requestIdleCallback(loaded, {timeout: 150}) : setTimeout(loaded);
    }, false);
  }
}
window.customElements.define('lazy-image', LazyImage, { extends: 'img' });

class ProgPicture extends HTMLPictureElement {
  constructor() {
    super();

    this.abortController = new AbortController();
    this.addEventListener('touchmove', this.touchmove_handler, { signal: this.abortController.signal });
  }

  touchmove_handler(ev) {
    if (ev.scale > 1) {
      var hqImage = this.getAttribute('data-hq');
      this.querySelector('source').setAttribute('srcset', hqImage);
      this.abortController.abort();
    }
  }
}
window.customElements.define('prog-picture', ProgPicture, { extends: 'picture' });